export { default as PartsTab } from './parts-tab';
export { default as OtherPartsTab } from './other-parts-tab';
export { default as ChecklistTab } from './checklist-tab';
export { default as InfoTab } from './info-tab';
